import { MembershipType } from '@typings/operations';

export const isMemberOrRotaractor = (membershipType: string | undefined) =>
  membershipType === MembershipType.Member ||
  membershipType === MembershipType.Rotaractor;
